module.exports = __webpack_public_path__ + "img/pelaku-perbukuan.209d6988.svg";